import { render, staticRenderFns } from "./pickupManagement.vue?vue&type=template&id=14542a26&scoped=true"
import script from "./pickupManagement.vue?vue&type=script&lang=js"
export * from "./pickupManagement.vue?vue&type=script&lang=js"
import style0 from "./pickupManagement.vue?vue&type=style&index=0&id=14542a26&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14542a26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14542a26')) {
      api.createRecord('14542a26', component.options)
    } else {
      api.reload('14542a26', component.options)
    }
    module.hot.accept("./pickupManagement.vue?vue&type=template&id=14542a26&scoped=true", function () {
      api.rerender('14542a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/pickupManagement.vue"
export default component.exports